<template>
  <!-- 企业上云 -->
  <div class="enterpriseCloudUp">
    <div class="top-banner-box">
      <div class="top-banner-img" :style="{ backgroundImage: `url(${headerBgUrl})` }">
        <div class="banner-btn" @click="tianbao">上云填报</div>
      </div>
    </div>
    <!-- 列表信息记录 -->
    <div class="listInfo">
      <div class="apply-box f-r j-b a-c">
        <div class="apply-title">{{ title }}</div>
        <div class="f-r">
          <div class="record-btn" @click="changeType('0')" :class="type == '0' ? 'cur' : ''">上云填报记录</div>
          <div class="record-btn" @click="changeType('1')" :class="type == '1' ? 'cur' : ''">填报申请记录</div>
          <div class="record-btn" @click="changeType('2')" :class="type == '2' ? 'cur' : ''">上云评分</div>
        </div>
      </div>
      <!-- 分割线 -->
      <div class="divider"></div>
      <div v-if="type == '0'">
        <el-table :data="dataList" border style="width: 100%">
          <el-table-column prop="scores" label="综合评分" align="center" />
          <el-table-column prop="cloudInput" label="上云级别" align="center" />
          <el-table-column prop="status" label="当前状态" align="center">
            <template slot-scope="scope">
              <span>{{scope.row.status | getStatus(that)}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="modifyTime" label="填报时间" align="center" />
          <el-table-column label="操作" :width="250" align="center">
            <template slot-scope="scope">
              <span
                v-if="scope.row.status == 'COMMITTED'"
                @click="check(scope.row)"
                class="checkBtn"
              >
                <i class="el-icon-view"></i>
                查看
              </span>
              <span
                v-if="scope.row.status == 'COMMITTED'"
                @click="report(scope.row)"
                class="checkBtn btn"
              >生成报告</span>
              <span
                v-if="scope.row.status == 'UNCOMMITTED'"
                @click="goOnfill(scope.row)"
                class="checkBtn"
              >继续填报</span>
            </template>
          </el-table-column>
        </el-table>
        <commonPag
          v-show="dataList.length > 0"
          @currentChange="currentChange"
          :total="total"
          :pageSize="10"
          :currentPage="currentPage"
        ></commonPag>
      </div>
      <applyRecord v-else-if="type == '1'" />
      <cloudUpScore v-else-if="type == '2'" :uuid="uuid" />
    </div>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
      <div v-if="!ifAgain" style="margin-bottom:10px">请填写填报原因</div>
      <div v-else style="margin-bottom:10px">请填写再次填报原因</div>
      <el-input v-model="reason" clearable></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitReason">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  cloudUpFillList,
  getVerifyResult,
  saveReason,
  createPdf
} from "../../utils/interface";
import commonPag from "../../components/commonPag.vue";
import applyRecord from "./applyRecord.vue";
import cloudUpScore from "./cloudUpScore.vue";
import fillStep from "./fillStep.vue";
export default {
  name: "",
  components: { commonPag, applyRecord, cloudUpScore, fillStep },
  props: {},
  data() {
    return {
      that: this,
      headerBgUrl: require("@/assets/publicService/cloudUp/bannerBg.png"),
      title: "上云填报记录",
      type: "0", // 0表示上云填报记录，1表示填报申请记录，2表示上云评分
      dataList: [],
      buttonList: [
        { name: "查看", type: "check" },
        { name: "生成报告", type: "other", btn: true },
        { name: "继续填报", type: "other" }
      ],
      total: 0,
      currentPage: 1,
      statusList: [
        { label: "未提交", value: "UNCOMMITTED" },
        { label: "提交", value: "COMMITTED" }
        // { label: "同意", value: "AGREE" },
        // { label: "拒绝", value: "REJECT" }
      ],
      dialogVisible: false,
      reason: "", // (再次)申报原因
      ifAgain: false, // 是否是再次填报
      uuid: "" // 当前条uuid
    };
  },
  filters: {
    getStatus(val, that) {
      if (val) {
        return that.statusList.filter(el => el.value == val)[0].label;
      } else {
        return;
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (from.name == "fillStep") {
        // 如果从申报详情页返回，展示申报记录列表页
        vm.query();
      }
    });
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {
    if (this.$route.query.code == "0") {
      this.type = "0";
    } else if (this.$route.query.code == "1") {
      this.type = "1";
    } else if (this.$route.query.code == "2") {
      this.type = "2";
    }
    let timer = setInterval(() => {
      // 当获取到当前登录人的uuid时，才去调查询接口
      if (this.$store.state.isUsermessage.uuid) {
        this.query();
        clearInterval(timer);
      }
    }, 100);
  },
  methods: {
    query() {
      return new Promise((resolve, reject) => {
        if (!this.$store.state.isUsermessage.uuid) {
          resolve();
        }
        cloudUpFillList({
          userId: this.$store.state.isUsermessage.uuid,
          current: this.currentPage,
          pageSize: 10
        }).then(res => {
          if (res.list && res.list.length > 0) {
            this.dataList = res.list;
            this.total = res.total;
            resolve();
          } else {
            this.dataList = [];
            this.total = 0;
            resolve();
          }
        });
      });
    },
    /* 改变按钮选择 */
    changeType(type) {
      if (type == "2" && this.dataList.length == 0) {
        // 没有评分记录时，点击上云评分跳转至填报申请记录
        this.$message({
          type: "warning",
          message: "暂无填报记录，请填报"
        });
        return;
      }
      switch (type) {
        case "0":
          this.title = "上云填报记录";
          break;
        case "1":
          this.title = "填报申请记录";
          break;
        case "2":
          this.title = "上云评分";
          this.uuid = "";
          break;
      }
      this.type = type;
    },
    /* 上云填报 */
    async tianbao() {
      await this.query();
      let newToken = this.$cookies.get("api_token_new");
      if (!newToken) {
        // 未登录的话先登录
        this.$router.push("/login");
      } else if (
        this.$store.state.isUsermessage.identity === "PERSONAL" ||
        this.$store.state.isUsermessage.identity === "ANONYMOUS"
      ) {
        // 没有经过企业认证的话去认证
        this.$confirm("请先进行企业资质认证!", "提示", {
          confirmButtonText: "去认证",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          window.sessionStorage.setItem("userServeId", "11");
          let routeData = this.$router.resolve({
            name: "userCenter",
            params: {
              userServeId: "11"
            }
          });
          window.open(routeData.href, "_target");
        });
        return false;
      } else {
        let flag = true; // true 表示当前列表全都提交过了，false表示有未提交的记录
        let uuid;
        if (this.dataList.length == 0) {
          // 若没有填报过，直接去填报
          let routeData = this.$router.resolve({
            name: "fillStep"
          });
          window.open(routeData.href, "_target");
        } else {
          // 有填报记录，判断是不是所有记录都生成报告了
          this.dataList.map(el => {
            if (el.status == "UNCOMMITTED") {
              flag = false;
            }
          });
          if (flag) {
            // 若当前记录全部提交，则调接口查看最新的一条原因有没有通过，通过则直接去填。
            this.getVerifyResult();
          } else {
            // 若有未提交的记录,则继续这条信息去填写
            uuid = this.dataList.filter(el => el.status == "UNCOMMITTED")[0]
              .uuid;
            this.$nextTick(() => {
              // 如果当前有填报中的申请，即只保存未提交，则去该条继续编辑
              let routeData = this.$router.resolve({
                name: "fillStep",
                query: {
                  uuid,
                  type: "edit"
                }
              });
              window.open(routeData.href, "_target");
            });
          }
        }
      }
    },
    /* 查询最新一条填报申请通不通过 */
    getVerifyResult() {
      getVerifyResult(this.$store.state.isUsermessage.uuid).then(res => {
        if (!res.data) {
          // 如果返回结果为空，则表示没有填报申请，则弹出填报申请的窗口去填写申请原因
          this.ifAgain = false;
          this.dialogVisible = true;
          this.reason = "";
        } else {
          // 如果返回结果不为空
          if (res.data.status == "COMMITTED") {
            // 填报结果是提交状态，表示还未审核，提示“您的申请还在审核中，请等待”
            this.$confirm("您的申请还在审核中，请等待!", "提示", {
              confirmButtonText: "确认",
              cancelButtonText: "取消",
              type: "warning"
            }).then(() => {});
          } else if (res.data.status == "REJECT") {
            // 填报结果是拒绝状态，表示审核已拒绝，提示“审核不通过”，若点击确定，弹出可以再次填写申请原因的窗口，提示“请再次填写填报原因”
            this.ifAgain = true;
            this.$confirm("审核不通过!", "提示", {
              confirmButtonText: "确认",
              cancelButtonText: "取消",
              type: "warning"
            }).then(() => {
              this.dialogVisible = true;
              this.reason = "";
            });
          } else if (res.data.status == "AGREE") {
            // 填报结果是同意状态，表示审核已同意，则去修改上一条上云申请
            // let routeData = this.$router.resolve({
            //   name: "fillStep"
            // });
            // window.open(routeData.href, "_target");
            this.dialogVisible = true;
            this.reason = "";
          }
        }
      });
    },
    /* 填报原因 */
    submitReason() {
      saveReason({
        userId: this.$store.state.isUsermessage.uuid,
        userName: this.$store.state.isUsermessage.name,
        reason: this.reason
      }).then(res => {
        if (res.success) {
          this.$message({
            message: res.message,
            type: "success"
          });
          this.dialogVisible = false;
        }
      });
    },
    check(row) {
      this.type = "2";
      this.uuid = row.uuid;
    },
    report(row) {
      // 生成报告
      createPdf({ uuid: row.uuid }).then(res => {
        this.downloadBlobFile(res, row.name);
      });
    },
    /* blob二进制文件下载 */
    downloadBlobFile(data, name) {
      const link = document.createElement("a");
      let blob = new Blob([data], { type: `application/pdf` });
      // console.log("type", type, "blob", blob);
      link.style.display = "none";
      link.href = window.URL.createObjectURL(blob);
      let num = "";
      for (let i = 0; i < 10; i++) {
        num += Math.ceil(Math.random() * 10);
      }
      link.setAttribute("download", `${name}上云评分.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    goOnfill(row) {
      let routeData = this.$router.resolve({
        name: "fillStep",
        query: {
          uuid: row.uuid,
          type: "edit"
        }
      });
      window.open(routeData.href, "_target");
    },
    currentChange(Page) {
      this.currentPage = Page.currentPage;
      this.query();
    }
  }
};
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";

.enterpriseCloudUp {
  position: relative;
  top: -80px;
  margin-bottom: -80px;

  .top-banner-box {
    // background-color: #f7f8fb;

    .top-banner-img {
      height: 300px;
      width: 100%;
      overflow: hidden;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;

      .banner-btn {
        position: absolute;
        cursor: pointer;
        bottom: 78px;
        font-size: 16px;
        width: 112px;
        height: 38px;
        .lh(38px);
        text-align: center;
        background-color: #f6c506;
        border-radius: 19px;
        letter-spacing: 1.5px;
      }
    }
  }

  .listInfo {
    position: relative;
    width: 1300px;
    min-height: 500px;
    margin: 0 auto;
    top: -60px;
    background-color: #fff;
    box-sizing: border-box;
    padding: 20px 20px 0;
    .br();
    .bd();

    .divider {
      height: 2px;
      background-color: #efefef;
      padding: 0 20px;
      margin: 25px 0;
    }

    .checkBtn {
      color: #2d50a1;
      margin: 0 4px;
      &:hover {
        cursor: pointer;
      }
    }

    .btn {
      color: #fff;
      padding: 2px 4px;
      border-radius: 4px;
      .bc();
    }

    .apply-box {
      .apply-title {
        font-size: 24px;
        font-weight: 600;
        position: relative;

        &::after {
          content: "";
          position: absolute;
          width: 100%;
          height: 2px;
          background-color: @basic-colors;
          bottom: 0;
          left: 0;
          top: 58px;
        }
      }

      .cur {
        .bc(100%) !important;
      }

      .record-btn {
        height: 38px;
        padding: 0 8px;
        color: #fff;
        cursor: pointer;
        margin-left: 8px;
        .bc(50%);
        .lh(38px);
        .bs();
        .br(4px);
      }
    }
  }
  /deep/ .el-dialog__body {
    padding: 5px 20px 30px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/enterpriseCloudUp/index.vue